import React, { useEffect, useState } from "react";
import Layout from "../../../layout";

import { Link } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

const MarcoHistoricoListar = () => {
  const [state, setState] = useState([]);

  const carregarDados = async () => {
    try {
      showLoading(".ibox-content");

      const requisicao = await api.get("/marco-historico");

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setState(data.data);
      window.$("#table-marco-historico").footable();
      showLoading(".ibox-content");
    } catch (error) {
      console.log(error);
      showLoading(".ibox-content");
      danger("Erro ao carregar os dados dos marcos históricos");
    }
  };

  useEffect(() => carregarDados(), []);

  const excluirMarcoHistorico = (marcoHistorico) => {
    window.swal(
      {
        title: "Você tem certeza?",
        text: `Deseja realmente excluir o marco histórico ${marcoHistorico.titulo}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        closeOnConfirm: true,
      },
      async () => {
        try {
          const { data } = await api.delete(
            `/marco-historico/${marcoHistorico.id}`
          );

          if (!data.status) {
            danger(data.mensagem);
            return;
          }

          success(data.mensagem);

          carregarDados();
        } catch (error) {
          console.log(error);
          danger("Erro ao deletar o marco histórico");
        }
      }
    );
  };

  return (
    <>
      <Layout
        titulo="Ibraflex - Marcos Históricos"
        header="Listagem de Marcos Históricos"
        action={{ titulo: "Cadastrar", link: "/marco-historico/cadastrar" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox">
              <div className="ibox-title">
                <h5>Listagem dos marcos históricos cadastrados</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                {state.length <= 0 ? (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-marco-historico"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Titulo</th>
                          <th>Ano</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                    </table>
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-marco-historico"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Titulo</th>
                          <th>Ano</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.map((marcoHistorico) => (
                          <tr key={marcoHistorico.id}>
                            <td>{marcoHistorico.id}</td>
                            <td>{marcoHistorico.titulo}</td>
                            <td>{marcoHistorico.ano}</td>
                            <td>
                              <div className="btn-group">
                                <button
                                  data-toggle="dropdown"
                                  className="btn btn-success btn-xs dropdown-toggle"
                                >
                                  Opções
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <Link
                                      to={{
                                        pathname: "/marco-historico/editar",
                                        state: { id: marcoHistorico.id },
                                      }}
                                      className="dropdown-item"
                                      id="editar"
                                    >
                                      Editar
                                    </Link>
                                  </li>
                                  <li>
                                    <a
                                      href="#!"
                                      className="dropdown-item"
                                      id="alerta-excluir"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        excluirMarcoHistorico(marcoHistorico);
                                      }}
                                    >
                                      Excluir
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="4">
                            <ul className="pagination float-right"></ul>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default MarcoHistoricoListar;
